import { render, staticRenderFns } from "./UrunRezervasyonBilgiTur.vue?vue&type=template&id=91a67e66&scoped=true"
import script from "./UrunRezervasyonBilgiTur.vue?vue&type=script&lang=js"
export * from "./UrunRezervasyonBilgiTur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a67e66",
  null
  
)

export default component.exports